import querySerializer from 'query-string';
import restoreScroll from 'redux-first-router-restore-scroll';
import { NOT_FOUND, redirect } from 'redux-first-router';

export default {
	querySerializer,
	restoreScroll: restoreScroll({
		shouldUpdateScroll: (prev, locationState) => {
			if (Object.keys(locationState).length === 0) {
				// console.log('DEBUG: scroll top');
				return [0, 0];
			}

			// Changing route when scrolling on category page. Don't adjust scroll
			if (locationState?.payload?.skipClearAppend) {
				// console.log('DEBUG: no scroll');
				return false;
			}

			// Don't adjust scroll if just changing language.
			if (locationState.payload && prev.payload.language !== locationState.payload.language) {
				return false;
			}

			return true;
		},
	}),
	onBeforeChange: (dispatch, getState, bag) => {
		// Control that we have language, else add language.
		// Add hash as a payload parameter.

		const languages = Object.keys(getState().environment.setup.languages);
		const { payload, meta } = bag.action;
		let { type } = bag.action;
		let { language = '', path = '', search = '', hash = '' } = payload;
		if (Object.keys(payload).length === 0) return true;
		let update = false;

		if (!language && path && languages.indexOf(path) !== -1) {
			language = path;
			path = '';
		}

		if (!language && languages.length > 1 && getState().environment.setup.language !== 'en') {
			language = getState().environment.setup.language;
			update = true;
		}

		if (languages.length > 1 && languages.indexOf(language) === -1 && getState().environment.setup.language !== 'en') {
			path = path ? `${language}/${path}` : `${language}`; // "language" is really a path.
			language = getState().environment.setup.language;
			type = 'CATEGORY_PRODUCT_PAGE';
			update = true;
		}

		search = search || meta.query || '';

		if (path.indexOf('#') !== -1 && hash === '') {
			hash = path.slice(path.indexOf('#'));
			path = path.slice(0, path.indexOf('#'));
			update = true;
		}

		if (update && type !== NOT_FOUND) {
			return dispatch(redirect({ type, payload: { ...payload, language, path, search, hash } }));
		}

		return true;
	},
};
